import {
  List,
  Datagrid,
  ChipField,
  TextField,
  UrlField,
  SearchInput,
  SelectInput,
  TextInput,
  DeleteWithConfirmButton,
  Edit,
  SimpleForm,
  Create,
  Show,
  SimpleShowLayout,
} from 'react-admin'

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const NetworkList = ({ isEdit, isDelete }) => (
  <List
    filters={[
      <SearchInput source="search" alwaysOn />,
      <SelectInput source="type" choices={[{ id: 'EVM', name: 'EVM' }]} />,
      <TextInput source="chainId" />,
      <TextInput source="search" />,
    ]}
  >
    <Datagrid bulkActionButtons={false} rowClick={isEdit ? 'edit' : 'show'}>
      <ChipField source="type" />
      <TextField source="chainId" />
      <TextField source="name" />
      <TextField source="symbol" />
      <UrlField source="iconUrl" />
      <UrlField source="explorerUrl" />
      {isDelete && (
        <DeleteWithConfirmButton confirmContent="This action could not be reverted. Are you sure?" />
      )}
    </Datagrid>
  </List>
)

export const NetworkEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="chainId" />
      <TextInput source="name" />
      <TextInput source="symbol" />
      <TextInput source="iconUrl" type="url" />
      <TextInput source="explorerUrl" type="url" />
    </SimpleForm>
  </Edit>
)

export const NetworkCreate = () => (
  <Create>
    <SimpleForm>
      <SelectInput source="type" choices={[{ id: 'EVM', name: 'EVM' }]} />
      <TextInput source="chainId" />
      <TextInput source="name" />
      <TextInput source="symbol" />
      <TextInput source="iconUrl" type="url" />
      <TextInput source="explorerUrl" type="url" />
    </SimpleForm>
  </Create>
)

export const NetworkShow = () => (
  <Show>
    <SimpleShowLayout>
      <ChipField source="type" />
      <TextField source="chainId" />
      <TextField source="name" />
      <TextField source="symbol" />
      <UrlField source="iconUrl" />
      <UrlField source="explorerUrl" />
    </SimpleShowLayout>
  </Show>
)
